<template>
    <div>
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">
                                <router-link :to="{path:'/dashboard'}">Inicio</router-link>
                            </li>
                            <li class="breadcrumb-item" aria-current="page" v-if="type==='admin'">
                                <router-link :to="{path:'/admin/grupos'}">Grupos</router-link>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page" style="text-transform: capitalize">
                                {{sede}}
                            </li>
                        </ol>
                    </nav>
                </div>

                <div class="col-md-12">
                    <h3>Seleccione un día</h3>
                </div>

                <div class="col-md-3" style="margin-bottom: 20px" v-for="day in dias">
                    <router-link :to="{path:'/admin/grupos/'+sede+'/'+day.dia}">
                        <div class="panel">
                            <div class="row">
                                <div class="col-md-12" style="padding-right: 0">
                                    <img src="img/logo.png" class="imgPanel img-fluid">
                                </div>
                            </div>
                            <p class="text-center txtPanel noselect">{{day.dia}}</p>
                        </div>
                    </router-link>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';
    import swal from 'sweetalert2'
    import BTooltipDirective from 'bootstrap-vue/es/directives/tooltip'


    export default {
        data() {
            return {
                sede: this.$route.params.sede,
                type: this.$store.getters.type,
                dias: []
            };
        },
        directives: {
            'b-tooltip': BTooltipDirective
        },
        created() {
            this.loadDays();
        },
        methods: {
            loadDays() {
                let vm = this;
                axios.get(this.$store.getters.apiUrl + 'horas/' + this.sede + '/dias', {
                    params: {
                        sede: vm.sede,
                        jwt: vm.$store.getters.jwt,
                        season: vm.$store.getters.season
                    }
                }).then(response => {
                    if (response.data.response) {
                        vm.dias = response.data.result;
                    } else {
                        swal({
                            title: 'Atención',
                            text: response.data.message,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });

                    }
                }).catch(e => {
                    swal({
                        title: 'Atención',
                        text: e,
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                });
            }
        }

    };
</script>
<style scoped>

    .container-fluid {
        margin-top: 39px;
    }

    .panel {
        cursor: pointer;
        text-align: center;
        padding: 15px;
        border-radius: 5px;
        border: 1px solid #cdcdcd;
        background-color: #f1f1f1;
        transition: background-color 0.2s;
    }

    .panel:hover {
        background-color: #36305c;
    }

    .panel:hover p {
        color: #eee;
        text-shadow: 2px 2px 2px #000;
    }

    .txtPanel {
        font-size: 1.6em;
        margin-top: 30px;
        color: #111;
        text-shadow: 2px 2px 2px #eee;
    }

    .imgPanel {
        margin-top: 20px;
        padding: 12px;
        background-color: #fff;
        border-radius: 5%;
        max-width: 150px;
    }

    @media (max-width: 600px) {
        .imgPanel {
            max-width: 100px;
        }
    }

    .noselect {
        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Safari */
        -khtml-user-select: none; /* Konqueror HTML */
        -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
        user-select: none;
        /* Non-prefixed version, currently
                                         supported by Chrome and Opera */
    }


</style>
